import { CreateContainer } from "../../../Containers/ContainerCreate";
import EndlessScrollContainer from "../../../Containers/EndlessScrollContainer";
import { getGenreTracks } from "../../../api/getGenre";

class EndlessScrollGenreTracksContainer extends EndlessScrollContainer {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            hasMore: false,
            type: "track",
            filter: props.filter || "",
            items: [],
            isLoading: false,
            initialLoading: true
        };
    }

    fetch = () => {
        if (this.state.isLoading) {
            return;
        }

        this.setState({ isLoading: true });
        const genreId = this.props.filter || this.state.filter;
        this.props.request(genreId, this.state.page).then(({ data }) => {
            // Check if there are more pages based on total count
            const tracks = data.tracks || [];
            const total = data.total || 0;
            const items = [...this.state.items, ...tracks];
            const hasMore = items.length < total;
            this.setState({
                items,
                page: this.state.page + 1,
                hasMore,
                isLoading: false,
                initialLoading: false
            }, () => {
                // Notify parent of items count change
                if (this.props.onItemsChange) {
                    this.props.onItemsChange(items.length);
                }
            });
        }).catch(() => {
            this.setState({ isLoading: false, initialLoading: false });
        });
    };

    componentDidUpdate(prevProps, prevState) {
        // Notify parent when items change (e.g., on initial load)
        if (prevState.items.length !== this.state.items.length && this.props.onItemsChange) {
            this.props.onItemsChange(this.state.items.length);
        }
    }
}

EndlessScrollGenreTracksContainer.defaultProps = {};
export default CreateContainer(getGenreTracks, EndlessScrollGenreTracksContainer);

